
import styles from './index.module.scss'
import GoBack from "../components/GoBack"
import { useState, useContext, useMemo, useEffect, useRef } from "react"
import { useNavigate, useParams, useLocation } from "react-router-dom"
import { CloseOutlined } from '@ant-design/icons';
import { Button, Modal, Input, message } from 'antd';
import Iconfont from '@utils/Iconfont';
import PictureViewModal from '../components/PictureViewModal'
import API from "@api/api";
import Utils from '@utils/utils';
import useBatchListResult from "./useBatchListResult";
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { DISPLAY_TYPE, BATCH_IMAGES_TYPE, SMART_DETAIL_COMP_LABEL_MAP } from '@utils/CONST'
import PSAIModal from '@PSAIComponents/PSAIModal';
import { BatchImagesContext } from '../BatchImagesContext'
import RefListModal from '../components/RefListModal'
import GroupWrapLeft from './GroupWrapLeft'
import useDownloadSmartPageImags from './useDownloadSmartPageImags'
import BottomBtnGroups from '../components/BottomBtnGroups'
import SkuSidebar from './SkuSidebar'
import SmartDetailPagePreview from '@view/page_v3/MiddleComp/SmartDetailPagePreview'
import PreviewBottomActions from '@view/page_v3/MiddleComp/SmartDetailPagePreview/components/PreviewBottomActions'
import MaterialEditModal from '@view/page_v3/MiddleComp/SmartDetailPagePreview/MaterialEditModal'



const ResultsPage = (props) => {
    const navigate = useNavigate()
    const { selectSkuId } = useContext(BatchImagesContext)
    const { isProCenter } = useLocation().state || {}
    const { projectId } = useParams()
    const modalRef = useRef(null)
    const previewBottomActionsRef = useRef(null)
    const [skuList, setSkuList] = useState([])
    const [editNameVisible, setEditNameVisible] = useState(false)
    const [nickName, setNickName] = useState('')
    const [projectName, setProjectName] = useState('')
    const [projectSerial, setProjectSerial] = useState('')
    const { dataList, groupedData, refresh, projectType } = useBatchListResult(projectId)
    const refListModalRef = useRef(null)

    const { downloadZip, loading, progress } = useDownloadSmartPageImags()

    // 生成页面左侧SKU列表
    const batchListSkuCoverList = () => {
        API.batchListSkuCoverList({
            projectId: projectId
        }).then(res => {
            if (res.code === 0) {
                setSkuList(res.data.skuDetailList || [])
                setProjectName(res.data.projectName || '')
                setProjectSerial(res.data.projectSerial || '')
                setNickName(res.data.projectName || '')
                setActiveSku(pre => !pre ? res.data.skuDetailList?.[0]?.skuId || '' : pre)
            } else if (res?.code == -5003) {
                navigate("/home/product/batchImages")
                message.error(res.message)
            }
        })
    }

    useEffect(() => {
        if (!selectSkuId) return
        setActiveSku(selectSkuId)
    }, [selectSkuId])


    useEffect(() => {
        if (dataList?.length == 0) return
        // 只有当所有项的 status 都为 succeeded 或 failed 时才设置已读
        const allCompleted = dataList.every(item =>
            item.status === 'succeeded' || item.status === 'failed'
        );
        if (allCompleted) {
            API.batchResetUnread({ projectId: projectId })
        }
        batchListSkuCoverList()
    }, [dataList])


    // 大图弹窗
    const [isModalOpen, setIsModalOpen] = useState(false)
    const [item, setItem] = useState()
    const [taskId, setTaskId] = useState()
    const [modalOpenFlag, setModalOpenFlag] = useState(false)
    const [materialModalOpen, setMaterialModalOpen] = useState(false)
    const [materialEditItem, setMaterialEditItem] = useState(null)
    const [materialGenerating, setMaterialGenerating] = useState(false)
    useEffect(() => {
        if (!isModalOpen) {
            setTaskId()
            setItem()
        }
    }, [isModalOpen])
    const handleCLick = (item) => {
        if (item.status != "succeeded") return
        setItem(item)
        setTaskId(item?.taskId)
    }

    const handelVideoPlay = async (e, play) => {
        try {
            const videoEl = e?.currentTarget?.querySelector('video')
            if (!videoEl) return
            if (play) await videoEl.play()
            else await videoEl.pause()
        } catch (err) {
            console.error(err)
        }
    }

    useEffect(() => {
        if (item && taskId) {
            setIsModalOpen(true)
        }
    }, [item, taskId])

    const openMaterialEditModal = (targetItem) => {
        if (!targetItem || targetItem?.status !== 'succeeded') return
        setMaterialEditItem(targetItem)
        setMaterialModalOpen(true)
    }

    const handleMaterialGenerate = async ({ desc, referImage, item: currentItem }) => {
        if (!currentItem?.taskId || !desc) return
        try {
            setMaterialGenerating(true)
            const res = await API.batchDoEditDetailPage({
                taskId: currentItem?.taskId?.split('_')?.[0] || currentItem?.taskId,
                imageId: currentItem?.results?.[0]?.id,
                prompt: desc,
                refImage: referImage || '',
                meta: Number(currentItem?.attr?.comp ?? currentItem?.comp ?? 0),
            })
            if (res?.code !== 0) throw new Error(res?.message || '生成失败')
            message.success('生成中，请稍候！')
            setMaterialModalOpen(false)
            setMaterialEditItem(null)
            refresh()
            batchListSkuCoverList()
        } catch (err) {
            message.warning(err?.message || '生成失败')
        } finally {
            setMaterialGenerating(false)
        }
    }


    // ============= 🔹 核心逻辑：滚动绑定 =============
    const groupRefs = useRef({}) // 保存右侧每个 skuId 对应的 div
    const [activeSku, setActiveSku] = useState(null)
    const isSmartDetailProject = projectType == BATCH_IMAGES_TYPE.SMART_DETAIL_PAGE_BATCH

    const handleScrollToSku = (skuId) => {
        setActiveSku(skuId)
        if (isSmartDetailProject) return
        const target = groupRefs.current?.[skuId]
        if (!target) return
        target.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
            inline: 'nearest',
        })
    }

    const smartDetailGroupedData = useMemo(() => {
        if (!activeSku) return groupedData || []
        return (groupedData || []).filter((group) => group?.[0]?.skuId === activeSku)
    }, [groupedData, activeSku])
    const displayGroupedData = isSmartDetailProject ? smartDetailGroupedData : (groupedData || [])
    const pickedSortedItems = useMemo(() => {
        return (smartDetailGroupedData || [])
            .flat()
            .filter(item => item?.results?.[0]?.picked)
            .map((item, index) => ({ item, index }))
            .sort((a, b) => {
                const aSortIdx = Number(a?.item?.attr?.sortIdx ?? a?.item?.sortIdx)
                const bSortIdx = Number(b?.item?.attr?.sortIdx ?? b?.item?.sortIdx)
                const aValue = Number.isFinite(aSortIdx) ? aSortIdx : Number.MAX_SAFE_INTEGER
                const bValue = Number.isFinite(bSortIdx) ? bSortIdx : Number.MAX_SAFE_INTEGER
                if (aValue !== bValue) return aValue - bValue
                return a.index - b.index
            })
            .map(({ item }) => item)
    }, [smartDetailGroupedData])
    const previewImageUrls = useMemo(() => {
        return pickedSortedItems
            .map(item => item?.results?.[0]?.hdImage || item?.results?.[0]?.image)
            .filter(Boolean)
    }, [pickedSortedItems])
    const selectedTaskIds = useMemo(() => {
        return [...new Set(
            pickedSortedItems
                .map(item => item?.taskId?.split('_')?.[0] || item?.taskId)
                .filter(Boolean)
        )]
    }, [pickedSortedItems])
    const selectedDownloadItems = useMemo(() => {
        return pickedSortedItems
            .map((item) => ({
                taskId: item?.taskId?.split('_')?.[0] || item?.taskId,
                imageId: item?.results?.[0]?.id,
            }))
            .filter(item => item?.taskId && item?.imageId)
    }, [pickedSortedItems])
    const isSmartDetailGenerating = useMemo(() => {
        return (smartDetailGroupedData || [])
            .flat()
            .some(item => ['started', 'pending', 'processing'].includes(item?.status))
    }, [smartDetailGroupedData])

    // 选择这张图
    const handleChoose = (e, item) => {
        e.stopPropagation()
        if (item.status != "succeeded") return
        console.log('item', item)
        API.batchPickImage({
            taskId: item.taskId.split('_')[0],
            imageId: item?.results?.[0]?.id
        }).then(res => {
            if (res.code === 0) {
                refresh()
                batchListSkuCoverList()
            }
        })
    }

    // 再次生成
    const regenerateByTaskId = (taskId) => {
        API.regenerateByTaskId({
            taskId: taskId.split('_')[0]
        }).then(res => {
            if (res.code === 0) {
                refresh()
            } else message.error(res.message)
        })
    }

    // 重新编辑
    const reEditClick = (projectId, skuId, taskId) => {
        navigate(`/home/product/${projectId}/config?skuId=${skuId}&taskId=${taskId.split('_')[0]}`)
    }

    // 更新名称
    const updateNameOk = async () => {
        if (!nickName.trim()) { message.warning('请输入项目名'); return; }
        const saveRes = await API.batchUpdateProject({
            projectName: nickName.trim(),
            projectId
        })

        if (saveRes?.code === 0) {
            setEditNameVisible(false)
            setNickName('')
            batchListSkuCoverList()
        }
    }

    return (
        <>
            <div className={styles.ResultsPage}>
                <div className={styles.GoBack}>

                    <GoBack onClick={() => isProCenter ? navigate('/home/myProject/batchImages') : navigate('/home/product/batchImages')} />

                    <span className={styles.TaskId}>项目ID：{projectSerial}</span>
                    <span className={styles.TaskTitle}>
                        {projectType == BATCH_IMAGES_TYPE.TRYON_BATCH ? 'AI试衣' :
                            projectType == BATCH_IMAGES_TYPE.CHANGE_MODEL_BATCH ? '换模特' :
                                projectType == BATCH_IMAGES_TYPE.SIM_RECOLOR_BATCH ? '同款换色' :
                                    projectType == BATCH_IMAGES_TYPE.IMAGE_FINER_BATCH ? 'AI超清' :
                                        projectType == BATCH_IMAGES_TYPE.WATERMARK_REMOVE_BATCH ? '去水印' :
                                            projectType == BATCH_IMAGES_TYPE.FUSIONWEAR_BATCH ? '搭配上身' :
                                                projectType == BATCH_IMAGES_TYPE.SMART_DETAIL_PAGE_BATCH ? '服装详情页' :
                                                projectType == BATCH_IMAGES_TYPE.GRASS_PLANT_BATCH ? '种草图' :
                                        projectType == BATCH_IMAGES_TYPE.IMAGE_TO_VIDEO_BATCH ? '图生视频' :
                                                        '换背景'}-{projectName}
                        <Iconfont className={styles.TaskTitleEditIcon} type="icon-Material-EditOutlined" onClick={() => setEditNameVisible(true)} /></span>
                </div>
                <div className={styles.ResultsPageWrap}>
                    <div className={styles.ResultsBox}>
                        <SkuSidebar
                            skuList={skuList}
                            activeSku={activeSku}
                            onSelectSku={handleScrollToSku}
                        />
                        <div className={`${styles.ResultsBoxRight} ${isSmartDetailProject ? styles.ResultsBoxRightSmartDetail : '_beauty_scrollbar'}`}>
                            <div className={isSmartDetailProject ? styles.SmartDetailPageWrapper : ''}>
                                <div className={isSmartDetailProject ? `${styles.SmartDetailMain} _beauty_scrollbar` : ''}>
                            {
                                displayGroupedData?.map((item, index) => (
                                    (() => {
                                        const displayItems = isSmartDetailProject
                                            ? (item || [])
                                                .map((taskItem, taskIndex) => ({ taskItem, taskIndex }))
                                                .sort((a, b) => {
                                                    const aSortIdx = Number(a?.taskItem?.attr?.sortIdx)
                                                    const bSortIdx = Number(b?.taskItem?.attr?.sortIdx)
                                                    const aValue = Number.isFinite(aSortIdx) ? aSortIdx : Number.MAX_SAFE_INTEGER
                                                    const bValue = Number.isFinite(bSortIdx) ? bSortIdx : Number.MAX_SAFE_INTEGER
                                                    if (aValue !== bValue) return aValue - bValue
                                                    return a.taskIndex - b.taskIndex
                                                })
                                                .map(({ taskItem }) => taskItem)
                                            : (item || [])
                                        return (
                                    <div key={item[0]?.skuId + index}
                                        ref={(el) => {
                                            const skuId = item[0]?.skuId;
                                            // 只在该 skuId 第一次出现时记录 ref
                                            if (el && !groupRefs.current[skuId]) {
                                                groupRefs.current[skuId] = el;
                                            }
                                        }}
                                        className={styles.groupWrap}>
                                        <GroupWrapLeft
                                            projectType={projectType}
                                            item={item}
                                            refListModalRef={refListModalRef}
                                            regenerateByTaskId={regenerateByTaskId}
                                            reEditClick={reEditClick} />
                                        <div className={styles.groupWrapRight}>
                                            {
                                                displayItems.map((i, index) => (
                                                    i.status == 'started' || i.status == 'pending' ?
                                                        <div key={i?.taskId || index} className={styles.groupWrapRightItem}>
                                                            <img src={'https://photostudio-ai-oss.arcsoft.com.cn/photostudio-web/admin/images_v3/picWaitngBg.png'} alt="" />
                                                            <span className={styles.spanText}>排队中...</span>
                                                        </div> :
                                                        i.status == 'processing' ?
                                                            <div key={i?.taskId || index} className={styles.groupWrapRightItem}>
                                                                <span className={styles.spanText}>生成中...</span>
                                                                <video
                                                                    src="https://photostudio-ai-oss.arcsoft.com.cn/photostudio-web/admin/images_v3/picProcessingBg.webm"
                                                                    autoPlay loop muted></video>
                                                            </div> :
                                                            i.status == 'failed' ?
                                                                <div key={i?.taskId || index} className={styles.groupWrapRightItem} >
                                                                    <span className={styles.spanText}>生成失败</span>
                                                                </div> :
                                                                i.status == 'succeeded' ?
                                                                    <div key={i?.taskId || index} onClick={() => handleCLick(i)}
                                                                        className={`${styles.groupWrapRightItem} ${styles.successItem}
                                                                         ${projectType == BATCH_IMAGES_TYPE.WATERMARK_REMOVE_BATCH ?
                                                                                styles.groupWrapRightItemBatch : ''}`}>
                                                                        {
                                                                            projectType != BATCH_IMAGES_TYPE.IMAGE_TO_VIDEO_BATCH && <div className={styles.successItemMask}>查看大图</div>
                                                                        }
                                                                        {
                                                                            projectType == BATCH_IMAGES_TYPE.IMAGE_TO_VIDEO_BATCH ?
                                                                                <div
                                                                                    className={styles.videoBox}
                                                                                    onMouseEnter={(e) => handelVideoPlay(e, true)}
                                                                                    onMouseLeave={(e) => handelVideoPlay(e, false)}
                                                                                >
                                                                                    <video
                                                                                        src={i?.results?.[0]?.image}
                                                                                        muted
                                                                                        loop
                                                                                        disablePictureInPicture
                                                                                    />
                                                                                    <i className={styles.VideoIcon}></i>
                                                                                </div> :
                                                                                <LazyLoadImage
                                                                                    alt="example"
                                                                                    effect="blur"
                                                                                    src={Utils.getImgThumbnail(i.results?.[0]?.image)}
                                                                                    placeholderSrc={Utils.getImgThumbnail(i?.results?.[0]?.image)}
                                                                                />
                                                                        }
                                                                        {isSmartDetailProject && !i?.attr?.refTemplate && !i?.refTemplate && SMART_DETAIL_COMP_LABEL_MAP?.[Number(i?.attr?.comp ?? i?.comp)] && (
                                                                            <div className={styles.CompTag}>
                                                                                {SMART_DETAIL_COMP_LABEL_MAP[Number(i?.attr?.comp ?? i?.comp)]}
                                                                            </div>
                                                                        )}
                                                                        {
                                                                            <p className={`${styles.chooseBtn} ${i.results?.[0]?.picked ? styles.chooseBtnActive : ''}`}
                                                                                onClick={(e) => handleChoose(e, i)}>
                                                                                <Iconfont className={styles.Icon} type="icon-imgOutlined" />
                                                                                {i.results?.[0]?.picked ? '已选中' : '选这张'}
                                                                            </p>
                                                                        }
                                                                        {
                                                                            !isSmartDetailProject && projectType != BATCH_IMAGES_TYPE.IMAGE_TO_VIDEO_BATCH && <BottomBtnGroups
                                                                                item={i}
                                                                                reEditClick={reEditClick}
                                                                                className={styles.hideOnNormal}
                                                                                regenerateByTaskId={regenerateByTaskId} />
                                                                        }
                                                                        {isSmartDetailProject && (
                                                                            <span
                                                                                className={styles.MaterialEditTrigger}
                                                                                onClick={(e) => {
                                                                                    e.stopPropagation()
                                                                                    openMaterialEditModal(i)
                                                                                }}
                                                                            >
                                                                                <Iconfont type="icon-Material-EditOutlined" />
                                                                            </span>
                                                                        )}
                                                                    </div> : null
                                                ))
                                            }

                                        </div>

                                    </div>
                                        )
                                    })()
                                ))
                            }
                            {!isSmartDetailProject && <Button type="primary" className={styles.ViewSelectedBtn} onClick={() => navigate(`/home/product/${projectId}/selected`)}>
                                    {projectType == BATCH_IMAGES_TYPE.IMAGE_TO_VIDEO_BATCH ? '查看已选视频' : '查看已选图'}
                                </Button>}
                                </div>
                                {isSmartDetailProject && (
                                    <>
                                        <div className={styles.SmartDetailPreviewSide}>
                                            <SmartDetailPagePreview
                                                tasks={pickedSortedItems}
                                                className={styles.SmartDetailPreviewCard}
                                                isGenerating={isSmartDetailGenerating}
                                                onPreviewLongImage={() => previewBottomActionsRef.current?.previewLongImage?.()}
                                            />
                                        </div>
                                        <div className={styles.SmartDetailBottomActions}>
                                            <PreviewBottomActions
                                                ref={previewBottomActionsRef}
                                                imageUrls={previewImageUrls}
                                                selectedTaskIds={selectedTaskIds}
                                                selectedDownloadItems={selectedDownloadItems}
                                                isGenerating={isSmartDetailGenerating}
                                            />
                                        </div>
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Modal
                open={isModalOpen}
                onOk={() => setIsModalOpen(false)}
                footer={null}
                maskClosable={true}
                width="100%"
                style={{ top: 0, padding: 0, margin: 0, maxWidth: '100vw', height: '100vh' }}
                bodyStyle={{ height: '100vh', overflow: 'hidden' }}
                destroyOnHidden
                onCancel={() => setIsModalOpen(false)}
                className='PictureViewModal'
                afterOpenChange={(open) => setModalOpenFlag(open)}
                closeIcon={false}
            >
                <PictureViewModal
                    regenerateByTaskId={regenerateByTaskId} // 重新生成
                    reEditClick={reEditClick} // 重新编辑
                    handleChoose={handleChoose} // 选择图片
                    onOpenMaterialEdit={openMaterialEditModal}
                    modalOpenFlag={modalOpenFlag}
                    displayType={DISPLAY_TYPE.PROJECT}
                    setProjectId={() => null}
                    ref={modalRef}
                    taskId={taskId}
                    setTaskId={setTaskId}
                    isModalOpen={isModalOpen}
                    setIsModalOpen={setIsModalOpen}
                    item={item}
                    setItem={setItem}
                    groupedTasks={groupedData}
                    fetchProjectDetail={refresh} />
            </Modal>
            <PSAIModal
                title={'修改项目名'}
                maxWidth={400}
                okText={'确定'}
                open={editNameVisible}
                maskClosable={false}
                okButtonProps={{ disabled: false, loading: false }}
                onCancel={() => setEditNameVisible(false)}
                onOk={() => updateNameOk()}
            >
                <div className={styles.editNameContent}>
                    <Input
                        value={nickName}
                        suffix={`${nickName.length}/40`}
                        onChange={(e) => setNickName(e.target.value)}
                        maxLength={40}
                        placeholder='请输入新名称' />
                </div>
            </PSAIModal>
            <RefListModal projectType={projectType} ref={refListModalRef} />
            <MaterialEditModal
                open={materialModalOpen}
                onCancel={() => {
                    setMaterialModalOpen(false)
                    setMaterialEditItem(null)
                }}
                item={materialEditItem}
                onGenerate={handleMaterialGenerate}
                generating={materialGenerating}
            />
        </>

    )
}

export default ResultsPage
